import React, { useEffect, useState } from 'react'
import ModalLD3 from '../../../../../common/Modal/ModalLD3';
import { Button, ButtonGroup, Spinner } from '@livingdesign/react';
import AdvancedSelect from '../RecipientFilter/AdvancedSelect';
import { useAppContext } from '../../../../../../../contexts/Core';
import { RECIPIENT_FILTERS_ACCESS_ROLES, TEAM } from '../../../../../../../consts/DBFields';
import _ from 'lodash';
import "./SavedRecipientsShareModal.scss";
import { updateFilterAPI } from '../../../../../../../APIs/RecipientFilterAPI';
import { SNACK_TYPES } from '../../../../../../../consts/Common';

const QA_ID_PREFIX = `Recipient-SavedRecipientsShareModal`;

function SavedRecipientsShareModal({
    isOpen,
    onClose,
    title,
    subTitle,
    filter,
}) {

    const {
        teamUsers,
        selectedTeam,
        setSnackMessage,
        setSnackType,
    } = useAppContext();

    const [teamMembers, setTeamMembers] = useState([]);
    const [selectedMembers, setSelectedMembers] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if(_.isEmpty(teamUsers) || !selectedTeam?.[TEAM.ID]) return;
        const teamMembers = [];
        teamUsers[selectedTeam?.[TEAM.ID]]?.forEach( user => {
            teamMembers.push({
                label: `${user.preferred_name} - ${user.email}`,
                value: user.upn,
            });
        });
        setTeamMembers(teamMembers);
        if(filter?.sharedWith && filter.sharedWith.length > 0) {
            const selectedList = filter.sharedWith.map(sharedUser => {
                const preferred_name = teamMembers.find( member => member.value === sharedUser.upn )?.label || sharedUser.upn;
                return {
                    label: `${preferred_name}`,
                    value: sharedUser.upn,
                }
            });
            setSelectedMembers(selectedList);
        }
    }, [teamUsers, selectedTeam?.[TEAM.ID], filter?.sharedWith]);

    const handleMemberSelect = (selectedOptions) => {
        setSelectedMembers(selectedOptions);
    }

    const handleSubmit = async () => {
        setLoading(true);
        // Prepare sharedWith array
        const sharedWith = selectedMembers.map( member => ({
            upn: member.value,
            role: RECIPIENT_FILTERS_ACCESS_ROLES.EDIT
        }));
        // Call confirmCreateClick with sharedWith data
        const filterObj = {
            name: filter?.name,
            recipient_count: filter?.recipientCount,
            created_by: filter?.createdBy,
            team_id: filter?.teamId,
            filter: filter?.filter,
            shared_with: sharedWith,
        };
        try {
            const result = await updateFilterAPI(filter.filterId, filterObj);
            setSnackMessage("Recipient Filter shared successfully");
            setSnackType(SNACK_TYPES.SUCCESS);
            onClose();
        } catch (error) {
            setSnackMessage("Failed to update recipient filter");
            setSnackType(SNACK_TYPES.ERROR);
            return error;
        } finally {
            setLoading(false);
        }
    }

    return (
    <>
        <ModalLD3
            isOpen={isOpen}
            onClose={() => {
                if(loading) return;
                onClose();
            }}
            title={title}
            actions={
                <div data-testid={`${QA_ID_PREFIX}-actions`}>
                    <ButtonGroup data-testid={`${QA_ID_PREFIX}-button-group`}>
                        <Button
                            variant="tertiary"
                            size="medium"
                            onClick={() => {
                                if(loading) return;
                                onClose();
                            }}
                            data-testid={`${QA_ID_PREFIX}-cancel-button`}
                            disabled={loading}
                        >
                            Cancel
                        </Button>
                        <Button
                            variant="primary"
                            size="medium"
                            onClick={handleSubmit}
                            data-testid={`${QA_ID_PREFIX}-edit-button`}
                            disabled={loading}
                        >
                            {loading &&
                                <Spinner size="small" UNSAFE_className="button-spinner" data-testid={`${QA_ID_PREFIX}-spinner`} />
                            }
                            Create
                        </Button>
                    </ButtonGroup>
                </div>
            }
            size={"medium"}
            id={`${QA_ID_PREFIX}`}
            data-testid={`${QA_ID_PREFIX}-modal`}
        >
        <div data-testid={`${QA_ID_PREFIX}-subtitle`}>
            {subTitle}
        </div>
        <AdvancedSelect
            options={teamMembers}
            value={selectedMembers}
            onChange={handleMemberSelect}
            placeholder={undefined}
            isMulti={true}
            searchable={true}
            disabled={undefined}
            loading={undefined}
            isServerSideSearch={false}
            onSearch={undefined}
            searchDebounceMs={undefined}
            className={'recipient-filter-advanced-select'}
            maxDisplayedChips={2}
            noOptionsMessage={undefined}
            searchPlaceholder={undefined}
            showApplyButton={true}
            data-testid={`${QA_ID_PREFIX}-advanced-select`}
        />
        </ModalLD3>
    </>
    );
}

export default SavedRecipientsShareModal;